
<template>
    <div class="container-fluid bg-light bg-gradient pt-10" style="height: 100vh;">
        <div class="container bg-white lead text-dark p-5">
            <h2>{{ $translate('redirect_page_body_text', 'Redirecting').replace('{title}', '') }}</h2>
        </div>
    </div>
</template>
<script>
export default {
    async middleware({ store, $prismic, route }) {
        await store.dispatch('fetchStates', { $prismic, route });
    },
    head() {
        return {
            title: this.$translate('redirect_page_seo_title', 'Redirecting'),
            meta: [
                { name: 'robots', content: 'noindex' }
            ]
        };
    },
    mounted() {
        if (this.$route.query.link) {
            window.location.assign(this.$tracking.addTrackingParameters(decodeURIComponent(this.$route.query.link), this.$route.query));
        }
    }
};
</script>